// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__bk2p4","extendBeyond":"Divider_extendBeyond__K2fy8"};